import { CSSProperties } from "react";

export const StyleProps1: CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid #304aca",
};


export const StyleProps2: CSSProperties = {
    color: "black",
};


export const StyleProps3: CSSProperties= {
    color: "#304aca",
    textAlign: 'center'
};


